<template>
  <div>
    <chartMin :mdata="mData" />
  </div>
</template>

<script>
import chartMin from '../chartMin.vue'

export default {
  components: {
    chartMin
  },
  props: {
    urlId: {
      type: String,
      default: ''
    },
    isCard: {
      type: Boolean,
      default: false
    },
    resdata: {}
  },
  data () {
    return {
      gid: '',
      mData: []
    }
  },
  methods: {
    onInitMData () {
      let arr = this.resdata.data.kLineQuotes || []
      this.mData = arr.map(item => {
        let obj = item.quoteData
        return obj
      })
    }
  },
  created () {
    this.gid = this.isCard ? this.urlId : common.getUrlKey('gid')
    this.onInitMData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/chart/MLine/index.vue